import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_2ee6d999 from 'nuxt_plugin_bootstrapvue_2ee6d999' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_objectentries_388e6412 from 'nuxt_plugin_objectentries_388e6412' // Source: ./nuxt-polyfill/object.entries.js (mode: 'all')
import nuxt_plugin_arrayfrom_d57d98cc from 'nuxt_plugin_arrayfrom_d57d98cc' // Source: ./nuxt-polyfill/array-from.js (mode: 'all')
import nuxt_plugin_whatwgfetch_365bd2d7 from 'nuxt_plugin_whatwgfetch_365bd2d7' // Source: ./nuxt-polyfill/whatwg-fetch.js (mode: 'all')
import nuxt_plugin_intersectionobserver_a6042308 from 'nuxt_plugin_intersectionobserver_a6042308' // Source: ./nuxt-polyfill/intersection-observer.js (mode: 'all')
import nuxt_plugin_axios_69cd056a from 'nuxt_plugin_axios_69cd056a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_3b6baa11 from 'nuxt_plugin_pluginutils_3b6baa11' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_75ac11c8 from 'nuxt_plugin_pluginrouting_75ac11c8' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_93a8ac5a from 'nuxt_plugin_pluginmain_93a8ac5a' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_apollomodule_2390c736 from 'nuxt_plugin_apollomodule_2390c736' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_components_4e0136ac from 'nuxt_plugin_components_4e0136ac' // Source: ../plugins/components.js (mode: 'all')
import nuxt_plugin_beforeeach_3917639f from 'nuxt_plugin_beforeeach_3917639f' // Source: ../plugins/before-each.js (mode: 'all')
import nuxt_plugin_loadamplitude_1e08d354 from 'nuxt_plugin_loadamplitude_1e08d354' // Source: ../plugins/load_amplitude.js (mode: 'all')
import nuxt_plugin_timeago_e55ff71c from 'nuxt_plugin_timeago_e55ff71c' // Source: ../plugins/timeago.js (mode: 'all')
import nuxt_plugin_filters_2b4f519a from 'nuxt_plugin_filters_2b4f519a' // Source: ../plugins/filters.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Lernen einfach strukturiert | Lernpfad","htmlAttrs":{"lang":"de"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimal-ui"},{"name":"mobile-web-app-capable","content":"yes"},{"hid":"description","name":"description","content":"Lernpfad ist ein digitales Tool, das Lernen mit Inhalten aus unterschiedlichen digitalen Quellen vereinfacht."},{"property":"og:image","content":"\u002Fstatic\u002Ftheme\u002FImgLernen.png"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fstatic\u002Ftheme\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fx-icon","sizes":"16x16","href":"\u002Fstatic\u002Ftheme\u002Ffavicon-16x16.ico"},{"rel":"icon","type":"image\u002Fx-icon","sizes":"32x32","href":"\u002Fstatic\u002Ftheme\u002Ffavicon-32x32.ico"},{"rel":"icon","type":"image\u002Fx-icon","sizes":"96x96","href":"\u002Fstatic\u002Ftheme\u002Ffavicon-96x96.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Fstatic\u002Ftheme\u002Ffavicon-16x16.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Fstatic\u002Ftheme\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"96x96","href":"\u002Fstatic\u002Ftheme\u002Ffavicon-96x96.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"192x192","href":"\u002Fstatic\u002Ftheme\u002Fandroid-icon-192x192.png"},{"rel":"apple-touch-icon","sizes":"57x57","href":"\u002Fstatic\u002Ftheme\u002Fapple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"\u002Fstatic\u002Ftheme\u002Fapple-icon-60x60.png "},{"rel":"apple-touch-icon ","sizes":"72x72 ","href":"\u002Fstatic\u002Ftheme\u002Fapple-icon-72x72.png"},{"rel":"apple-touch-icon ","sizes":"76x76","href":"\u002Fstatic\u002Ftheme\u002Fapple-icon-76x76.png"},{"rel":"apple-touch-icon ","sizes":"114x114 ","href":"\u002Fstatic\u002Ftheme\u002Fapple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Fstatic\u002Ftheme\u002Fapple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002Fstatic\u002Ftheme\u002Fapple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152 ","href":"\u002Fstatic\u002Ftheme\u002Fapple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fstatic\u002Ftheme\u002Fapple-icon-180x180.png"},{"rel":"manifest","href":"\u002Fstatic\u002Ftheme\u002Fmanifest.json"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:wght@400;500;600;700;900&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins&display=swap"},{"name":"msapplication-TileColor","content":"#0f0a3b"},{"name":"msapplication-TileImage","content":"\u002Fstatic\u002Ftheme\u002Fms-icon-144x144.png"},{"name":"theme-color","content":"#0f0a3b"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_2ee6d999 === 'function') {
    await nuxt_plugin_bootstrapvue_2ee6d999(app.context, inject)
  }

  if (typeof nuxt_plugin_objectentries_388e6412 === 'function') {
    await nuxt_plugin_objectentries_388e6412(app.context, inject)
  }

  if (typeof nuxt_plugin_arrayfrom_d57d98cc === 'function') {
    await nuxt_plugin_arrayfrom_d57d98cc(app.context, inject)
  }

  if (typeof nuxt_plugin_whatwgfetch_365bd2d7 === 'function') {
    await nuxt_plugin_whatwgfetch_365bd2d7(app.context, inject)
  }

  if (typeof nuxt_plugin_intersectionobserver_a6042308 === 'function') {
    await nuxt_plugin_intersectionobserver_a6042308(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_69cd056a === 'function') {
    await nuxt_plugin_axios_69cd056a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3b6baa11 === 'function') {
    await nuxt_plugin_pluginutils_3b6baa11(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_75ac11c8 === 'function') {
    await nuxt_plugin_pluginrouting_75ac11c8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_93a8ac5a === 'function') {
    await nuxt_plugin_pluginmain_93a8ac5a(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_2390c736 === 'function') {
    await nuxt_plugin_apollomodule_2390c736(app.context, inject)
  }

  if (typeof nuxt_plugin_components_4e0136ac === 'function') {
    await nuxt_plugin_components_4e0136ac(app.context, inject)
  }

  if (typeof nuxt_plugin_beforeeach_3917639f === 'function') {
    await nuxt_plugin_beforeeach_3917639f(app.context, inject)
  }

  if (typeof nuxt_plugin_loadamplitude_1e08d354 === 'function') {
    await nuxt_plugin_loadamplitude_1e08d354(app.context, inject)
  }

  if (typeof nuxt_plugin_timeago_e55ff71c === 'function') {
    await nuxt_plugin_timeago_e55ff71c(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2b4f519a === 'function') {
    await nuxt_plugin_filters_2b4f519a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
